import { ID } from "src/libs/interfaces/layouts"
import { showToast } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import { accordeon, delimiter, description, horizontal_accordeon, horizontal_tab, title, vertical_timeline } from "../../data/defaults"
import { HISTORY_TYPE, IHistoryStep, ILanding } from "../../data/interfaces"
import { ILandingStore, useLandingStore } from "../../data/store"
import { components } from "../../data/utils/components"
import updateHistory from "../../views/landing/landing-edit/utils/updateHistory" 
/* Protopia Ecosystem component */
export interface IPresetLibraryListProps {
   libName?: string
   className?: string
   id?:ID
   onChange?: ( id: ID, preset: any ) => void
}
const presets: any = {
   title: {
      component: title()
   },
   description: {
      component: description()
   },
   delimiter: {
      component: delimiter()
   },
   horizontal_tab: {
      component: horizontal_tab()
   },
   horizontal_accordeon: {
      component: horizontal_accordeon()
   },
   accordeon: {
      component: accordeon()
   },
   vertical_timeline: {
      component: vertical_timeline()
   },
}



/** Список вариантов в библиотеке */
const PresetLibraryList = (props: IPresetLibraryListProps): JSX.Element => { 
   
   const comps = Object.keys(components())
      .filter((key: string) => !!components()[key].default)
      .map( (key: string) => ( {key, component: components()[key].default } ) )
      .reduce( 
         (acc: any, obj: any) => {
            acc[obj.key] = obj 
            return acc;
         }, 
         {}
      )
   const allPresets: any = {
      ...presets, 
      ...comps
   }
   return <div className={`landing-preset-library-list p-0 ${ props.className || "w_400 max_h_400" } overflow-y-auto`}> 
      <div className="w-100">
      { 
         allPresets[ props.libName || "" ]?.component.map(( preset: any, i:number ) => {
            return <PresetLibItem 
               name={ props.libName } 
               preset={ preset } 
               onChange={props.onChange} 
               id={props.id}
               key={ preset.id  } 
               i={i} 
            />
         })
      } 
      </div>
   </div>
}
export default PresetLibraryList

/** Элемент библиотеки */
const PresetLibItem = (props: any) : JSX.Element => { 
   const {currentLanding, currentEditData } = useLandingStore( (state:ILandingStore) => state )
   const onChoose = () => {
      const item = props.preset
      delete( item.id )
      item.libName = item.title
      delete( item.title )
      if(props.onChange) {
         props.onChange( props.id, item )
         return
      }
      const landing: ILanding = {
         ...currentLanding,
         [ props.name ]: item 
      }      
      if(!!currentEditData) { // если мы редактируем в SectionEditDraw.tsx
         const newData = { 
            currentEditData: {
                ...currentEditData,
                [ props.name ]: item 
            },
            readyToClose: false,
            // currentLanding: landing, // превью. Ели пользователь откажется от редактирования, объект присвоения из библиотеки вернётся в старое состояние.
         }
         console.log( newData )  
         useLandingStore.setState( newData )  
         showToast({
            message: __("The changes will take effect after saving all changes on the Drawer.")
         })
      } 
      else { // TODO:: не реализовано нигде?
         const step: IHistoryStep = {
            data:  item,
            prevData:  (currentLanding as any)[ props.name ],
            type: HISTORY_TYPE.SETTINGS,
            title : "Update preset from library"
         } 
         updateHistory( step, landing )  
      }
   }
   
   return <div className="mb-1 border border-contrast p-0">
      <div className="position-relative bg-light">
         <div className="p-1">
            <img src={`/assets/img/landing/defaults/${props.name}${props.i}.jpg`} alt='' width="100%" />
         </div> 
         <div className="d-flex justify-content-between align-items-center w-100 position-absolute22 left bottom px-1 user-select-none"> 
            <div className="small px-2 flex-grow-100 title text-uppercase">
               { __( props.preset.title ) }
            </div>
            <div  className="pointer" onClick={onChoose}>
               <div className="smallest letter-spacing-1 w-auto text-uppercase bg-success text-light px-3 py-1">
                  {__("Apply")}
               </div>
            </div>
         </div>
      </div>
   </div>
}